import { faqItems } from "@/mocks/homeData";

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            关于黄桃视频的使用与体验，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-100 rounded-xl p-6 border border-background-200/60"
            >
              <h3 className="text-base font-semibold text-foreground-900 mb-3 flex items-start gap-3 font-heading">
                <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0 text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}